import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS,I_COMMON_DELETE_PARAMS,I_COMMON_IMPORT_PARAMS} from './_base';

import I_BILLING_CUSTOMERS,{I_IMPORT_BILLING_CUSTOMERS_OK} from '../interfaces/I_BILLING_CUSTOMERS';
import {
  getBillingCustomersResponse,
  postBillingCustomerResponse,
  deleteBillingCustomerResponse,
  putBillingCustomerResponse,
  importBillingCustomersResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- BILLING CUSTOMERS
// ---------------------------------

const logger = LoggerService.getInstance();

/**
 * Récupère la liste des donneurs d'ordre
 * @param obj
 * @returns
 */
const getList = async ({accessToken,refreshToken,page,dispatch,state}:I_COMMON_GET_ALL_PARAMS):Promise<I_BILLING_CUSTOMERS> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - getBillingCustomers - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getBillingCustomersResponse({accessToken:usedAccessToken,page});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,
    state,
  });
  logger.debug('ApiServices - getBillingCustomers - returned response',response);
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_BILLING_CUSTOMERS = await response.json();
  logger.debug('ApiServices - getBillingCustomers - ok, returned body',body);
  return body;
};

interface I_CREATE_BILLING_CUSTOMER_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  name: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Crée un type de tache
 * @param param0
 * @returns
 */
const create = async ({accessToken,refreshToken,name,dispatch,state}:I_CREATE_BILLING_CUSTOMER_PARAMS):Promise<string> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - createillingCustomer - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    !name || name === null || name.trim() === ''
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing name',
      errorMessage: 'Missing name to post billing customer',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postBillingCustomerResponse({accessToken:usedAccessToken,name});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.debug('ApiServices - createBillingCustomer - returned response',response);
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - createBillingCustomer - ok, returned body',body);
  return body;
};

/**
 * Supprime un donneur d'ordre
 * @param param0
 * @returns
 */
const remove = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_DELETE_PARAMS):Promise<string> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - deleteBillingCustomer - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteBillingCustomerResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.debug('ApiServices - deleteBillingCustomer - returned response',response);
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - deleteBillingCustomer - ok, returned body',body);
  return body;
};

interface I_BILLING_CUSTOMER_TYPE_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  id: number,
  name: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Modifie un type de tache
 * @param param0
 * @returns
 */
const update = async ({accessToken,refreshToken,id,name,dispatch,state}:I_BILLING_CUSTOMER_TYPE_PARAMS):Promise<string> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - updateBillingCustomer - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    id === undefined || id === null ||
    !name || name === null || name.trim() === ''
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing id, name',
      errorMessage: 'Missing id, name to put billing customer',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putBillingCustomerResponse({accessToken:usedAccessToken,id,name});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.debug('ApiServices - updateBillingCustomer - returned response',response);
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateBillingCustomer - ok, returned body',body);
  return body;
};



/**
 * Modifie un type de tache
 * @param param0
 * @returns
 */
const importList = async ({
  accessToken,refreshToken,file, dispatch,state
}:I_COMMON_IMPORT_PARAMS):Promise<I_IMPORT_BILLING_CUSTOMERS_OK> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - importBillingCustomers - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (!file) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing file',
      errorMessage: 'Missing file to post billing customers',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return importBillingCustomersResponse({
        accessToken:usedAccessToken,file,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.debug('ApiServices - importBillingCustomers - returned response',response);
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_IMPORT_BILLING_CUSTOMERS_OK = await response.json();
  logger.debug('ApiServices - importBillingCustomers - ok, returned body',body);
  return body;
};

const billingCustomersServices = {
  getList,
  create,
  remove,
  update,
  importList,
};

export default billingCustomersServices;
